export const metaTitlesAr = {
    homePageMetaTitle: "خدمات الذكاء الاصطناعي، البلوك تشين والتكنولوجيا | Bitsclan لحلول تكنولوجيا المعلومات",
    industyPageTitle: "حلول تكنولوجيا المعلومات المتخصصة لكل قطاع | Bitsclan",
    engagementModelPageTitle: "نماذج التعاقد المرنة لحلول تكنولوجيا المعلومات | Bitsclan IT Solutions",
    lifeAtBitsclanTitle: "الوظائف في Bitsclan | اكتشف الفرص وثقافة العمل",
    blogsTitle: "استكشف مدونتنا | أحدث المستجدات في الذكاء الاصطناعي، البلوك تشين والتكنولوجيا من Bitsclan",
    portFolioTitle: "أعمالنا | استعرض مشاريع Bitsclan البرمجية الناجحة",
    contactUsTitle: "تواصل معنا للحصول على خدمات احترافية | Bitsclan IT Solutions",

    aiPageTitle: "خدمات تطوير الذكاء الاصطناعي | حلول مخصصة للذكاء الاصطناعي وتعلم الآلة | Bitsclan",
    webAppDevTitle: "خدمات تطوير تطبيقات الويب حسب الطلب | Bitsclan IT Solutions",
    cyberSecPageTitle: "احمِ عملك مع خدمات الأمن السيبراني | Bitsclan",
    customSoftwareTitle: "شركة تطوير البرمجيات المخصصة | Bitsclan IT Solutions",
    blockChainTitle: "أفضل خدمات تطوير البلوك تشين | Bitsclan IT Solutions",
    mobileAppDevTitle: "خدمات تطوير تطبيقات الجوال | حلول مخصصة لنظامي iOS وAndroid",
    dataAnalyticsTitle: "خدمات تحليلات البيانات | علم البيانات | Bitsclan IT Solutions",
    devOpsMetaTitle: "خدمات وحلول DevOps | Bitsclan IT Solutions",
    qaMetaTitle: "خدمات ضمان جودة البرمجيات | شركة لاختبار وضمان الجودة",

    hireRoRTitle: "وظّف مبرمجي Ruby on Rails | خدمات تطوير RoR",
    hireDjangoTitle: "وظّف مطوري Django | خدمات تطوير Django",
    hirePythonTitle: "وظّف مطوري Python | خدمات تطوير Python",
    hireGolangTitle: "وظّف مطوري Golang | خدمات تطوير Golang",
    hireJavascriptTitle: "وظّف مطوري JavaScript | خدمات تطوير JavaScript",
    hireReactTitle: "وظّف مطوري React JS | خدمات تطوير React JS",
    hireFlutterTitle: "وظّف مطوري Flutter | خدمات تطوير Flutter",
    hireAndroidTitle: "وظّف مطوري android | تطوير تطبيقات الجوال المخصصة",
    hireAngularTitle: "وظّف مطوري Angular | خدمات تطوير Angular",
    hireMernTitle: "وظّف مطوري MERN Stack | تطوير الويب المتكامل (Full-Stack)",
    hireNodeTitle: "وظّف مطوري Node.js | خدمات تطوير Node.js",

    healthcareTitle: "خدمات تطوير البرمجيات للرعاية الصحية | حلول آمنة وقابلة للتوسع",
    ecommerceTitle: "خدمات تطوير البرمجيات المخصصة للبيع بالتجزئة | حقق النجاح في قطاع التجزئة",
    fintechTitle: "خدمات تطوير برمجيات التكنولوجيا المالية | حلول مالية من الجيل التالي",
    edtechTitle: "خدمات تطوير البرمجيات التعليمية | حلول ذكية للتعلم",
    realEstateTitle: "تطوير برمجيات العقارات | تحويل إدارة الممتلكات",
    insuranceTitle: "خدمات تطوير البرمجيات لقطاع التأمين | حلول رقمية موثوقة",
    logisticsTitle: "خدمات تطوير البرمجيات للوجستيات | تحسين عمليات سلسلة التوريد",
    automotiveTitle: "خدمات تطوير البرمجيات لصناعة السيارات | قيادة الابتكار والكفاءة",
    gamingTitle: "خدمات تطوير الألعاب | حلول ألعاب غامرة وقابلة للتوسيع",
    entertainmentTitle: "خدمات تطوير البرمجيات لقطاع الترفيه | جذب الجماهير بحلول مبتكرة",
    socialMediaTitle: "خدمات تطوير تطبيقات الشبكات الاجتماعية | بناء مجتمعات رقمية تفاعلية",
    telecomTitle: "خدمات تطوير البرمجيات للاتصالات | تمكين الاتصال والابتكار",
    energyTitle: "خدمات تطوير البرمجيات لقطاع الطاقة | تعزيز التحول الرقمي في مجال الطاقة",
    agricultureTitle: "خدمات تطوير البرمجيات لقطاع الزراعة | زراعة حلول الزراعة الذكية"
};